import React from "react";

export default function CourseMaterials() {
  return (
    <div className="mx-auto max-w-screen-xl	 w-full px-4 mt-16 mb-4">
      <h2 className="text-3xl mb-4 text-center">Course Materials</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 mx-auto place-content-center">
        <div className="card bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">1-1</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">1-2</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">2-1</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">2-2</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">3-1</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">3-2</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">4-1</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
        <div className="card   bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">4-2</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
              consequuntur.
            </p>
            <div className="card-actions justify-end">
              <a href="" className="btn btn-ghost">
                Get Materials
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
